export const appConfig = {
  database:
    "https://paymentapp-e4f92-default-rtdb.europe-west1.firebasedatabase.app",
  appkey: "AIzaSyBVrfOSbakO1_PVBexPT12InknxMfUI7As",
  lang: "pl",
};
